import { useCallback, useMemo } from 'react';

import useUrlState from '@dashboard/hooks/useUrlState';

import {
  AI_USAGE_PERIODS,
  type AiUsagePeriod,
  DEFAULT_AI_USAGE_PERIOD,
  periodRange,
} from './aiUsagePeriod';

const isPeriod = (value: unknown): value is AiUsagePeriod =>
  AI_USAGE_PERIODS.includes(value as AiUsagePeriod);

export default function useAiUsagePeriod() {
  const [query, setQuery] = useUrlState() as [
    Record<string, unknown>,
    (updates: Record<string, unknown>) => void,
  ];

  const period = isPeriod(query.period) ? query.period : DEFAULT_AI_USAGE_PERIOD;
  // Rolling periods start relative to now; recomputing per render would change the query keys every render.
  const range = useMemo(() => periodRange(period), [period]);
  const setPeriod = useCallback((next: AiUsagePeriod) => setQuery({ period: next }), [setQuery]);

  return { period, range, setPeriod };
}
